import { MDBDataTable } from "mdbreact";
import React, { Component } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
//Import actions redux
import {
  deleteUser, disableUser,
  enableUser,
  userChangePassword
} from "../../store/actions";


class WarningList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      warninglist: this.props.warninglist,
      actionUsr: false,
      pswd: false,
      usrToAction: null,
      action: null,
      new_pwd: null,
    };
  }


  render() {
    return (
      <React.Fragment>
        <MDBDataTable responsive striped bordered data={this.state.warninglist}
        paginationLabel={[this.props.t("Previous"), this.props.t("Next")]}
        entriesLabel={this.props.t("Show alerts")}
        noRecordsFoundLabel={this.props.t("No matching records found")}
          infoLabel={[
              this.props.t("Showing"),
              this.props.t("to"),
              this.props.t("of"),
              this.props.t("entries"),
            ]}
        searchLabel={this.props.t("Search")}
         />
      </React.Fragment>
    );
  }
}

const mapStateprops = (state) => {
  const {
    disableError,
    disableMessage,
    loadingDisableUser,
    enableError,
    enableMessage,
    loadingEnableUser,
  } = state.StatusUser;
  const { changeSuccessMsg, changeError } = state.ChangePassword;
  const {
    deleteUserError,
    deleteUsermessage,
    loadingDeleteUser,
  } = state.DeleteUser;
  return {
    disableError,
    disableMessage,
    loadingDisableUser,
    enableError,
    enableMessage,
    loadingEnableUser,
    changeSuccessMsg,
    changeError,
    deleteUserError,
    deleteUsermessage,
    loadingDeleteUser,
  };
};
export default withRouter(
  connect(mapStateprops, {
    disableUser,
    enableUser,
    userChangePassword,
    deleteUser,
  })(withNamespaces()(WarningList))
);
